import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@/context/ThemeContext';
import { AuthProvider, useAuth } from '@/context/AuthContext';
import Layout from '@/components/layout/Layout';
import LoginPage from '@/pages/LoginPage';
import UsersPage from './pages/UsersPage';
import TrainingDashboardPage from './pages/TrainingDashboardPage';
import TrainingsPage from './pages/TrainingsPage';
import LibraryPage from './pages/LibraryPage';
import QuestionnairePage from './pages/QuestionnairePage';
import ConfigurationPage from './pages/ConfigurationPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import PlaceholderPage from '@/pages/PlaceholderPage';
import ProtectedRoute from '@/components/common/ProtectedRoute';
import AdminRoute from '@/components/common/AdminRoute';

function DefaultRedirect(): JSX.Element {
  const { isFullAdmin, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <div className="spinner" />
      </div>
    );
  }

  return <Navigate to={isFullAdmin ? '/usuarios' : '/dashboard-capacitaciones'} replace />;
}

function App(): JSX.Element {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />

            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/usuarios" element={<AdminRoute><UsersPage /></AdminRoute>} />
              <Route path="/capacitacion" element={<AdminRoute><TrainingsPage /></AdminRoute>} />
              <Route path="/biblioteca" element={<AdminRoute><LibraryPage /></AdminRoute>} />
              <Route path="/cuestionarios" element={<AdminRoute><QuestionnairePage /></AdminRoute>} />

              <Route path="/dashboard-capacitaciones" element={<TrainingDashboardPage />} />
              <Route path="/configuracion" element={<ConfigurationPage />} />
            </Route>

            <Route path="/" element={<DefaultRedirect />} />
            <Route path="*" element={<DefaultRedirect />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;